import { render, staticRenderFns } from "./menu_tree.vue?vue&type=template&id=3d281d16&scoped=true&"
import script from "./menu_tree.vue?vue&type=script&lang=js&"
export * from "./menu_tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d281d16",
  null
  
)

export default component.exports